module.exports = __webpack_public_path__ + "static/media/PlanOptimized.3348f02e.jp2";